import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "../common/breadcrumb";
import Datatable from "./usersDatatable";
import { Search, Users, UserPlus, Phone, Mail, Bell, Send } from "react-feather";
import "./users-kido.css";
import { getAllUsersRedux } from "../../actions/index";
import { connect } from "react-redux";
import { sendNotifications } from "../../firebase/fcmRestApi";
import { getAllDeviceTokens } from "../../firebase/firebase.utils";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
export class List_user extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allUsers: [],
      searchFor: "",
      messageBody: "",
      campaign_title: "",
    };
  }

  componentDidMount = async () => {
    await this.props.getAllUsersRedux();
    this.setState({ allUsers: this.props.allUsers });
  };
  handleSearchBarChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
    console.log(this.state.searchFor);
  };
  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleSubmit = async () => {
    const { allUsers } = this.props;
    const UsersWithToken = allUsers.filter(
      (user) => user.deviceToken && user.deviceToken.length > 0
    );

    const message = {
      title: this.state.campaign_title,
      body: this.state.messageBody,
    };

    const allTokens = await getAllDeviceTokens();
    for (let i = 0; i < allTokens.length; i++) {
      const token = allTokens[i];
      sendNotifications(token, message);
    }

    toast.success("Notification sent successfully!");
  };

  render() {
    const { allUsers, searchFor, campaign_title, messageBody } = this.state;
    let renderableUsers = allUsers;
    if (!searchFor) {
      renderableUsers = allUsers;
    } else {
      renderableUsers = allUsers.filter(
        (user) =>
          (user.userId && user.userId.includes(searchFor)) ||
          (user.displayName &&
            user.displayName.toLowerCase().includes(searchFor.toLowerCase()))
      );
    }

    const monthStart = new Date();
    monthStart.setDate(1);
    monthStart.setHours(0, 0, 0, 0);
    const joinedThisMonth = allUsers.filter((u) => {
      const secs = u.createdAt && (u.createdAt.seconds || u.createdAt._seconds);
      return secs && secs * 1000 >= monthStart.getTime();
    }).length;
    const withMobile = allUsers.filter((u) => u.mobileNo || u.mobileNumber).length;
    const withEmail = allUsers.filter((u) => u.email).length;

    const stats = [
      { label: "Customers", value: allUsers.length, tone: "sky", Icon: Users },
      { label: "Joined this month", value: joinedThisMonth, tone: "mint", Icon: UserPlus },
      { label: "With mobile", value: withMobile, tone: "butter", Icon: Phone },
      { label: "With email", value: withEmail, tone: "lilac", Icon: Mail },
    ];

    return (
      <Fragment>
        <Breadcrumb title="Customers" parent="Users" />
        <div className="container-fluid">
          <section className="card kd-orders-card kd-users">
            <div className="kd-ord-top">
              <div className="kd-ord-title">
                <span className="kd-ord-title-tile kd-st--sky" aria-hidden="true">
                  <Users size={20} />
                </span>
                <div>
                  <h2>Customers</h2>
                  <svg className="kd-squiggle" viewBox="0 0 120 10" aria-hidden="true" focusable="false">
                    <path d="M2 6 Q12 1 22 6 T42 6 T62 6 T82 6 T102 6 T118 5" />
                  </svg>
                </div>
              </div>

              <form
                className="kd-ord-search"
                role="search"
                onSubmit={(e) => e.preventDefault()}
              >
                <Search size={16} aria-hidden="true" />
                <input
                  name="searchFor"
                  value={searchFor}
                  type="search"
                  placeholder="Search by name or customer ID"
                  aria-label="Search customers"
                  onChange={this.handleSearchBarChange}
                />
              </form>

              <button
                type="button"
                className="btn btn-secondary kd-users-notify"
                data-toggle="modal"
                data-target="#personalInfoModal"
              >
                <Bell size={15} aria-hidden="true" />
                Send notification
              </button>
            </div>

            <div className="kd-ord-summary">
              <div className="kd-ord-stats kd-users-stats">
                {stats.map(({ label, value, tone, Icon }, i) => (
                  <div key={label} className={`kd-stat-tag kd-st--${tone}`} style={{ "--i": i }}>
                    <span className="kd-stat-label">
                      <Icon size={13} aria-hidden="true" />
                      {label}
                    </span>
                    <span className="kd-stat-value">{value.toLocaleString()}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="kd-users-body">
              {searchFor && (
                <p className="kd-users-found">
                  {renderableUsers.length}{" "}
                  {renderableUsers.length === 1 ? "customer matches" : "customers match"} “{searchFor}”
                </p>
              )}
              <Datatable
                myData={renderableUsers.sort(
                  (a, b) => parseInt(a.userId) - parseInt(b.userId)
                )}
                resetKey={searchFor}
                emptyText={
                  searchFor
                    ? "No customers match your search."
                    : "No customers yet."
                }
              />
            </div>
          </section>
        </div>
        <ToastContainer />

        <div
          className="modal fade tb-modal"
          id="personalInfoModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document" style={{ margin: "auto" }}>
            <div className="modal-content" style={{ top: 10, width: "100%", margin: "auto" }}>
              <div className="modal-header">
                <div className="modal-title" id="exampleModalLabel">
                  Send a notification
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="kd-users-notify-body">
                  <div className="form-group">
                    <label htmlFor="kd-notify-title">Title</label>
                    <input
                      id="kd-notify-title"
                      type="text"
                      name="campaign_title"
                      className="form-control"
                      placeholder="e.g. New winter collection is here!"
                      onChange={this.handleChange}
                      value={campaign_title}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="kd-notify-body">Message</label>
                    <textarea
                      id="kd-notify-body"
                      name="messageBody"
                      className="form-control"
                      placeholder="What do you want to tell your customers?"
                      style={{ minHeight: 120 }}
                      onChange={this.handleChange}
                      value={messageBody}
                      required
                    />
                  </div>

                  {/* What customers will see on their phone */}
                  <div className="kd-notify-preview" aria-label="Preview">
                    <span className="kd-notify-preview-label">Preview</span>
                    <div className="kd-notify-bubble">
                      <span className="kd-notify-app" aria-hidden="true">K</span>
                      <span className="kd-notify-text">
                        <strong>{campaign_title || "Your title"}</strong>
                        <small>{messageBody || "Your message shows up here."}</small>
                      </span>
                      <span className="kd-notify-now">now</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-dismiss="modal">
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn"
                  data-dismiss="modal"
                  disabled={!campaign_title.trim() || !messageBody.trim()}
                  onClick={() => {
                    this.handleSubmit();
                  }}
                >
                  <Send size={14} aria-hidden="true" />
                  Send to all
                </button>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    allUsers: state.users.users,
  };
};
export default connect(mapStateToProps, { getAllUsersRedux })(List_user);
